import Vue from 'vue'
import { mapActions, mapGetters } from 'vuex'
import loadFormsComponents from './formsComponents.js'
import componentTools from '../../tools/components.js'
import PrismEditor from 'vue-prism-editor'
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'
import 'vue-prism-editor/dist/VuePrismEditor.css'
import tooltipCustomSolarFlux from '../../components/Tooltips/AnalyticalMission/tooltipCustomSolarFlux.vue'
import tooltipSKToleranceType from '../../components/Tooltips/AnalyticalMission/tooltipSKToleranceType.vue'
import tooltipOrbitPhasingOptimizationType from '../../components/Tooltips/AnalyticalMission/tooltipOrbitPhasingOptimizationType.vue'
import tooltipRaanPhasingReference from '../../components/Tooltips/AnalyticalMission/tooltipRaanPhasingReference.vue'
import tooltipOptimizationType from '../../components/Tooltips/AnalyticalMission/tooltipOptimizationType.vue'
import tooltipTargetDeltaRaan from '../../components/Tooltips/AnalyticalMission/tooltipTargetDeltaRaan.vue'
import tooltipTargetDeltaLtan from '../../components/Tooltips/AnalyticalMission/tooltipTargetDeltaLtan.vue'
import tooltipCoastingDomain from '../../components/Tooltips/AnalyticalMission/tooltipCoastingDomain.vue'
loadFormsComponents()
/* eslint-disable vue/no-dupe-keys */

export default () => {
  Vue.component('exo-input-parametric', {
    props: {
      root: Object,
      parentObject: {
        type: Object,
        default: null
      },
      tooltip: String,
      name: String,
      lockActive: {
        type: Boolean,
        default: false
      },
      onChangeCallback: {
        type: Function,
        default: function () {}
      }
    },

    data: () => ({
      menu: false,
      rangeTypes: ['Step', 'Number', 'Values'],
      inputError: false
    }),

    computed: {
      getParentObject() {
        return componentTools.getParentObject(this)
      },

      valuesToParse: {
        get() {
          let stringToDisplay = ''
          let valuesArray =
            this.getParentObject.parametricValues[this.name].values
          if (!Array.isArray(valuesArray) || !valuesArray.length) {
            return ''
          }
          for (let value of valuesArray) {
            stringToDisplay += value + ';'
          }
          stringToDisplay = stringToDisplay.substring(
            0,
            stringToDisplay.length - 1
          )
          return stringToDisplay
        },
        set(newValue) {
          let array = newValue.split(';')
          let parsedValues = []
          for (let str of array) {
            if (str !== '') {
              let isNumber = /^\d*\.?\d*$/.test(str)
              if (!isNumber) {
                parsedValues.push(str)
              } else {
                let number = parseFloat(str)
                parsedValues.push(number)
              }
            }
          }
          this.getParentObject.parametricValues[this.name].values = parsedValues
        }
      }
    },

    methods: {
      showMenu() {
        this.menu = true
        if (this.onChangeCallback) {
          this.onChangeCallback()
        }
      },
      displayMenuIfRange(name) {
        if (this.getParentObject.parametricValues[name].active) {
          this.menu = true
        }
      },
      getStringToDisplay() {
        let parametricField = this.getParentObject.parametricValues[this.name]
        if (parametricField.rangeType === 'Values') {
          if (
            Array.isArray(parametricField.values) &&
            parametricField.values.length
          ) {
            const min = Math.min(...parametricField.values)
            const max = Math.max(...parametricField.values)
            if (isNaN(min) || isNaN(max) || min < 0 || max < 0) {
              this.inputError = true
            } else {
              this.inputError = false
            }
            return 'min: ' + min + ' max: ' + max
          }
        }
        return 'min: ' + parametricField.min + ' max: ' + parametricField.max
      }
    },

    template: `
              <v-row no-gutters  v-if="root.isRequiredOrOptional(name, getParentObject)">
                <v-row no-gutters v-if="!getParentObject.parametricValues[name]">
                error : getParentObject.parametricValues['{{name}}'] not found. Please contact the software team and tell them they did a BIG mistake. Sorry about that.
                </v-row>
                <v-col @click="displayMenuIfRange(name)" cols="9" v-if="getParentObject.parametricValues[name]">
                  <v-menu
                    v-model="menu"
                    :disabled="!getParentObject.parametricValues[name].active"
                    :close-on-content-click="false"
                    transition="slide-y-transition"
                    nudge-top="15"
                    class="w-100"
                    offset-y
                    >
                    <template v-slot:activator="{ attrs }">
                      <v-tooltip bottom class="w-100" :disabled="!(tooltip !== '' && tooltip != null)">
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            :id="name"
                            v-on="on"
                            v-bind="attrs"
                            :disabled="getParentObject.parametricValues[name].active"
                            v-on:input="onChangeCallback"
                            v-model="getParentObject.parametricValues[name].active ? getStringToDisplay() : getParentObject[name]"
                            :rules="[root.getFieldState(getParentObject, name).message]"
                            :label="root.getFormLabel(name) + root.getDefaultUnitLabel(name)"
                          ></v-text-field>
                        </template>
                        <span>{{tooltip}}</span>
                      </v-tooltip>
                    </template>
                    <v-card>
                      <v-card-text>
                        <v-container class="py-0 pr-0">
                          <v-row>
                            <v-col cols="6">
                              <v-select
                              dense
                                :items="rangeTypes"
                                label="Range type"
                                v-on:change="root.updateParametricStepAndNumberfromParent(name, getParentObject)"
                                v-model="getParentObject.parametricValues[name].rangeType"
                                :menu-props="{transition:'scale-transition'}"
                              ></v-select>
                            </v-col>
                            <v-col cols="6">
                              <v-text-field
                              dense
                                :id="name+'-rangeStep'"
                                v-model="getParentObject.parametricValues[name].rangeStep"
                                v-on:input="root.updateParametricStepAndNumberfromParent(name, getParentObject)"
                                v-if="getParentObject.parametricValues[name].rangeType === 'Step'"
                                :rules="[root.getFieldState(getParentObject, name).rangeField.message]"
                                label="Step"
                              ></v-text-field>
                              <v-text-field
                              dense
                                :id="name+'-rangeNumber'"
                                v-model="getParentObject.parametricValues[name].rangeNumber"
                                v-on:input="root.updateParametricStepAndNumberfromParent(name, getParentObject)"
                                v-if="getParentObject.parametricValues[name].rangeType === 'Number'"
                                :rules="[root.getFieldState(getParentObject, name).rangeField.message]"
                                label="Number of points"
                              ></v-text-field>
                            
                              <v-text-field
                              dense
                                :id="name+'-values'"
                                v-model="valuesToParse"
                                v-if="getParentObject.parametricValues[name].rangeType === 'Values'"
                                :rules="[root.getFieldState(getParentObject, name).rangeField.message]"
                                placeholder="1; 2; 3"
                                label="Values"
                              ></v-text-field>
                              <exo-form-alert 
                                v-if="inputError && getParentObject.parametricValues[name].rangeType === 'Values'"
                              >
                                Only positive numbers are allowed.
                              </exo-form-alert>
                            </v-col>
                          </v-row>
                          <v-row v-if="getParentObject.parametricValues[name].rangeType !== 'Values'">
                            <v-col cols="6">
                              <v-text-field
                              dense
                              :id="name+'-min'"
                              v-model="getParentObject.parametricValues[name].min"
                              :rules="[root.getFieldState(getParentObject, name).min.message]"
                              label="Min"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="6">
                              <v-text-field
                              dense
                              :id="name+'-max'"
                              v-model="getParentObject.parametricValues[name].max"
                              :rules="[root.getFieldState(getParentObject, name).max.message]"
                              label="Max"
                              ></v-text-field>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-card-text>
                    </v-card>
                  </v-menu>
                </v-col>
                <v-col cols="1">
                  <slot></slot>
                </v-col>
                <v-col cols="2" v-if="getParentObject.parametricValues[name]">
                  <v-checkbox
                    :id="name+'-parametric'"
                    :disabled="lockActive"
                    v-model="getParentObject.parametricValues[name].active"
                    v-on:change="showMenu"
                    label="Range"
                  ></v-checkbox>
                </v-col>
              </v-row>
  `
  })

  Vue.component('exo-input-script', {
    props: {
      root: Object,
      parentObject: {
        type: Object,
        default: null
      },
      name: String
    },
    components: {
      PrismEditor
    },
    computed: {
      inputScriptFeedback() {
        let feedback = true
        if (this.inputScriptState !== null && !this.inputScriptState) {
          feedback = 'Allowed characters : a-z A-Z 0-9 _'
        }
        return feedback
      },
      inputScriptState() {
        let valid = null
        if (this.root.newCustomFieldName !== '') {
          let allowedChars = RegExp('^[a-zA-Z0-9_]+$')
          valid = allowedChars.test(this.root.newCustomFieldName)
        }
        return valid
      }
    },
    methods: {
      getCurrentFormType() {
        return 'ParametricScriptConfiguration'
      }
    },
    template: `
    <v-row no-gutters>
      <v-col v-if="parentObject != null">
        <exo-input-checkbox
          :root="root"
          :parentObject="parentObject"
          :forceDisplay="true"
          name="enableScript"
          alignWithParametricField
          customLabel="Custom variables and results"
          tooltip="Allows you to add a custom script to export additional data"
          :onChange="root.initScriptInput()"
        >
          <exo-help-dialog width="1000" margin="mb-7 ml-2" title="Custom script">
               <h4>General principles</h4>
               Create customized results by post-processing mission results.<br/>
               The script is executed for each value of the parameters, it is executed once all the other fields are evaluated.<br/> 
               It can not change the results computed by ExoOPS.<br/>
               The post-processing is evaluated on each result independently, there is no mean to compute global fields. <br/>
               E.g. evaluating an average or a maximum of one field is not possible.<br/>
               The customized result fields will be then accessible like the other result fields :
               <ul>
                 <li>to make a plot : they will be displayed in the data tree under <i>Script Inputs</i> and <i>Script outputs</i></li>
                 <li>to export :  they will be displayed in the data tree under <i>Script Inputs</i> and <i>Script outputs</i></li>
               </ul>
               
               <h4>Syntax</h4>
               The language used for scripting is Javascript.<br/>
               Loop (for/while) and conditions(if/then) can be used.<br/>
               Exception can be thrown :<br/>
<code>if (badCondition)
  throw 'My message will be displayed in the "Error Log" in the dashboard'</code><br/>
  <br/>
               If there is an error in the script (syntax error, runtime execution or exception thrown), 
               the error messages will be displayed in the "Error Log" in the result card of the dashboard.<br/>
               <br/>
               The custom results are exported thanks to this line at the end of the script :<br/>
               <code>exports // don't delete this line</code><br/>
               <br/>
               <code>exports</code> is a Javascript object that contains all custom fields. 
               Each custom field is identified by its identifier and needs 2 parameters : type and value. 
               The types are explained below.<br/>
               <code>exports.myVariableIdentifier = { type: 'percentage', value: evaluatedBefore}</code>
              
              <br/><br/>
               <h4>Types</h4>
               Types are only used in the outputs for unit conversion in the user interface.<br/>
               If creating a new output with type <i>duration</i>, the value can be converted in hours or days when used in plots.<br/>
               In ExoOPS all calculation are made with data in International System of units. 
               The units of all usable fields are specified in the script console.<br/>
               
               The available types are listed in the script console.<br/>
               If there is no type for the output or if the unit does not match one of the existing types, then the type <i>coefficient</i> should be used. 
               No data conversion would be available on the field.<br/>
               <br/>
               <h4>Custom inputs</h4>
               Custom inputs can be used to take a range of value into account to evaluate custom results.<br/>
               In the example below we could make the spacecraft volume vary and evaluate the volume ratio for each value.<br/>
               If a custom input is a single value (i.e. not a range of value), it should be directly declared in the script (like spacecraftVol in the example below)<br/> 
               There is no type in the input, like in local variables. Types are only used in the outputs for unit conversion in the user interface. <br/>
               <br/>
               <h4>Variables and Constants</h4>
               The script console list all the result fields generated by exoOPS, these fields can be used to evaluate custom outputs.<br/>
               Sub-fields can be accessed by concatenating objects : <code>mission.spacecraft.thruster.thrust</code> or <code>mission.finalOrbit.altitude</code><br/>
               On each object, the field <i>name</i> can be used.<br/>
               Some useful constants can be directly used in the code, there are listed in the script console.<br/>
               <br/>
               <h4>Mission additional data</h4>
               Each mission generates different kinds of results. E.g. a RAAN change mission will generate the coasting orbit description.<br/>
               A section in the script console display these additional data. Each additional field can be used like any other fields.<br/>
<br/>
               
               <h4>Example</h4>
               In this example we want to compare 2 propulsion systems named <i>1U</i> and <i>2U</i>. <br/>
               The mission should use a spacecraft with these 2 propulsion systems selected (multiple selection).<br/>
               We want to generate 3 new results :
               <ul>
               <li>the mass ratio of each propulsion system compare to the spacecraft mass</li>
               <li>the mass ratio of the propellant used compare to the spacecraft mass</li>
               <li>the volume ratio of each propulsion system compare to the spacecraft mass</li>
               </ul>
               For the 2 first results, the evaluation is easy as all required fields are already in the results 
               (spacecraft mass, propulsion system mass and propellant mass)<br/>
               For the volume ratio, an extra input is required : we need to specify the volume of each propulsion system.<br/>
               This can be easily done by using a value which depends on the propulsion system name.<br/>
               <br/>
               Note : volume are expressed in m³ in ExoOPS. But in that case we are doing ratio of values so the unit has no importance. 
               We just need to use the same unit for both the spacecraft and the propulsion system.
               <br/>
               <code>
               <br /> 
var exports = {} <br />    
<br />                                              
// mass ratios       <br />                                                                        
var massRatioValue = mission.spacecraft.thruster.totalMass / mission.spacecraft.platformMass     <br />          
exports.thrusterToSpacecraftMassRatio = {type: 'percentage', value: massRatioValue}          <br /> 
<br /> 
var propMassRatioValue = mission.usedPropellant / mission.spacecraft.platformMass             <br />        
exports.usedPropellantToSpacecraftMassRatio = {type: 'percentage', value: propMassRatioValue}<br /> 
<br /> 
// volume ratio                                                                             <br />  
var thrusterVol = 0 // U                                                                <br />      
var spacecraftVol = 20 // U                                                              <br />     
<br /> 
if (mission.spacecraft.thruster.name === '1U') {thrusterVol = 1}                          <br />    
else if (mission.spacecraft.thruster.name === '2U') {thrusterVol = 2}                      <br />   
else { throw 'Unknown volume of thruster '+ mission.spacecraft.thruster.name}              <br />   
<br /> 
var volRatioValue = thrusterVol / spacecraftVol                                            <br />   
exports.thrusterToSpacecraftVolumeRatio = { type: 'percentage', value: volRatioValue}        <br /> 
<br /> 
exports // returns data                                                                    <br />   
               </code>
               <br>
          </exo-help-dialog>
        </exo-input-checkbox>
        <v-col v-if="parentObject.enableScript" cols="12" height="350px"  v-on:keyup.enter="$event.stopPropagation()">
          <v-row no-gutters align="center">
            <v-col cols="2">
              <v-text-field
                label="Custom input name"
                v-model="root.newCustomFieldName"
                maxlength="100"
                :rules="[inputScriptFeedback]"
              >
              </v-text-field>
            </v-col>
            <v-col cols="4">
              <v-btn color="primary" class="ml-2" small v-on:click="root.addNewCustomField" :disabled="inputScriptState == null || !inputScriptState">
                <v-icon dark>add</v-icon>
                Add new custom input
              </v-btn>
            </v-col>
          </v-row>
          <v-col
            v-for="(input, key) in parentObject.scriptInputs"
            :key="key"
            px-3>
            <v-row align="center" no-gutters>
              <v-col cols="6">
                <exo-input-parametric
                  :root="root"
                  :label="'Custom input : ' + key"
                  :name="key"
                  lockActive>
                </exo-input-parametric>
              </v-col>
              <v-col cols="2">
                <v-btn v-on:click="root.deleteCustomField(key)">Delete</v-btn>
              </v-col>
            </v-row>
          </v-col>
          <prism-editor
            v-model="parentObject.script" language="js"
            :line-numbers="true"
            class="my-editor"
          />
        </v-col>
      </v-col>
    </v-row>
      `
  })

  Vue.component('exo-input-ref', {
    props: {
      root: Object,
      tooltip: String,
      parentObject: {
        type: Object,
        default: null
      },
      disableMultiple: {
        type: Boolean,
        default: false
      },
      name: String,
      type: String,
      componentRoute: String,
      onChangeCallback: {
        type: Function
      }
    },

    data() {
      return {
        hoverState: false
      }
    },

    computed: {
      getParentObject() {
        return componentTools.getParentObject(this)
      },
      styleObject() {
        return componentTools.styleObject(this)
      },
      ...mapGetters({
        editedComponentName: 'editedComponentName'
      })
    },
    methods: {
      ...mapActions(['updateEditedComponentName']),
      savePathToComeBack(item) {
        componentTools.setPathToComeBack(this, item)
        this.getParentObject[this.name] = componentTools.updateExoInput(
          this,
          item
        )
      }
    },
    template: `
              <v-row no-gutters  v-if="root.isRequiredOrOptional(name, getParentObject)">
               <v-col cols="12" v-if="!getParentObject.parametricReferences[name]">
                error : getParentObject.parametricReferences['{{name}}'] not found. Please contact the software team and tell them they did a BIG mistake. Sorry about that.
                </v-col>
                <v-col cols="9">
                <v-tooltip v-if="getParentObject.parametricReferences[name]" bottom :disabled="!(tooltip !== '' && tooltip != null)" nudge-top="45">
                  <template v-slot:activator="{ on }">
                  <v-row no-gutters>
                  <v-col>
                      <v-select
                        :id="name+'-nonParametric'"
                        :aria-test="name"
                        v-on:keyup.enter="$event.stopPropagation()"
                        :items="root[type + 's']"
                        v-model="getParentObject[name]"
                        v-on:input="onChangeCallback"
                        :label="root.getFormLabel(name)"
                        v-if="!getParentObject.parametricReferences[name].active"
                        :rules="[root.getFieldState(getParentObject, name).message]"
                      >
                        <template v-slot:item="{ item, index }">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-row no-gutters
                                @mouseover="item.editState = true"
                                @mouseout="item.editState = false"
                              >
                                <v-col cols="11" v-on="on"
                                  md-4 p-3 class="d-inline-flex ma-0 pa-0 justify-start align-center"
                                >
                                    <span>{{ item.text }}</span>
                                </v-col>
                                <v-col class="ma-0 pa-0" cols="1">
                                  <v-btn
                                    icon
                                    class="mx-0"
                                    :style="item.editState ? { display: 'inline-block'} : { display: 'none'}"
                                    @click="savePathToComeBack(item)">
                                    <v-icon size="20" color="primary">edit</v-icon>
                                  </v-btn>
                                </v-col>
                              </v-row>
                            </template>
                            <span style="margin: 0; padding: 0; white-space: pre-line" >{{  root.getInfos(item.value) }}</span>
                          </v-tooltip>
                        </template>
                        <template v-slot:append-item>
                         <v-row
                            @mouseover="hoverState = true"
                            @mouseout="hoverState = false"
                            @click="savePathToComeBack()"
                            style="cursor: pointer">
                          <v-divider class="m-0"></v-divider>
                         
                          <v-list-item disabled :style="styleObject">
                            <v-list-item-avatar>
                              <v-icon color="grey lighten-1">add</v-icon>
                            </v-list-item-avatar>
                    
                            <v-list-item-content>
                              <v-list-item-title>Create new {{root.getFormLabel(name).toLowerCase()}}</v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                          </v-row>
                        </template>
                      </v-select>
                      <v-select
                        :id="name+'-parametric'"
                        v-on:keyup.enter="$event.stopPropagation()"
                        v-model="getParentObject.parametricReferences[name].references"
                        :items="root[type + 'sNotParametricsId']"
                        v-if="getParentObject.parametricReferences[name].active"
                        :label="root.getFormLabel(name)"
                        multiple
                        chips
                      ></v-select>
                      </v-col> 
                      </v-row>
                  </template>
                  <span>{{tooltip}}</span>
                  
                </v-tooltip>
                </v-col>
                <v-col cols="1" />
                <v-col cols="2" v-if="getParentObject.parametricReferences[name] && !disableMultiple">
                    <v-checkbox
                      :id="name+'-multiple'"
                      v-on:change="onChangeCallback"
                      v-model="getParentObject.parametricReferences[name].active"
                      label="Multiple"
                    ></v-checkbox>
                </v-col>
              </v-row>
  `
  })

  Vue.component('exo-input-date', {
    props: {
      root: Object,
      parentObject: {
        type: Object,
        default: null
      },
      name: String,
      tooltip: String,
      type: String
    },

    data() {
      return {
        modal: false
      }
    },

    computed: {
      getParentObject() {
        return componentTools.getParentObject(this)
      }
    },

    template: `
    <v-tooltip bottom v-if="root.isRequiredOrOptional(name, getParentObject)">
      <template v-slot:activator="scope">
          <v-row no-gutters>
            <v-col sm="12" cols="8" d-flex v-on="scope.on">
              <v-dialog
                ref="dialog"
                v-model="modal"
                :return-value.sync="getParentObject[name]"
                persistent
                lazy
                full-width
                width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="getParentObject[name]"
                    :label="root.getFormLabel(name)"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="getParentObject[name]" scrollable>
                  <v-spacer></v-spacer>
                 <v-btn text color="red" @click="modal = false">Cancel</v-btn>
                 <v-btn text color="primary" @click="$refs.dialog.save(getParentObject[name])">OK</v-btn>
                </v-date-picker>
              </v-dialog>
            </v-col>
          </v-row>
      </template>
    <span>{{ tooltip }}</span>
  </v-tooltip>
  `
  })

  Vue.component('exo-input-maneuver', {
    props: ['maneuver', 'index', 'root'],
    components: {
      tooltipCustomSolarFlux,
      tooltipSKToleranceType,
      tooltipOrbitPhasingOptimizationType,
      tooltipRaanPhasingReference,
      tooltipOptimizationType,
      tooltipTargetDeltaRaan,
      tooltipTargetDeltaLtan,
      tooltipCoastingDomain
    },
    template: `
    <div>
      <v-divider></v-divider>
      <b>{{maneuver.type}}</b>
      <exo-form-alert type="warning" v-if="maneuver.type === 'Orbit Phasing' && root.inputs.dragPerturbationEnabled" >
      The drag perturbation won't be managed during Orbit Phasing missions.
      </exo-form-alert>
      <exo-input-ref-notparametric alignWithParametricField class="mb-0 pb-0" :root="root" name="finalOrbit" type="orbit" componentRoute="/analyticalorbit" :parentObject="maneuver"/>
      <exo-input-select alignWithParametricField :root="root" name="raanPhasingReference" :parentObject="maneuver">
        <tooltipRaanPhasingReference/>
      </exo-input-select>
      <exo-input-select alignWithParametricField :root="root" name="optimizationType" :parentObject="maneuver">
        <tooltipOptimizationType/>
      </exo-input-select>

      <exo-input-parametric :root="root" name="targetMissionDuration"  :parentObject="maneuver"/>

      <exo-input-select alignWithParametricField :root="root" name="targetRaanLtanType" :parentObject="maneuver"/>
      <exo-input-parametric class="mb-0 pb-0" :root="root" name="targetDeltaRaan" :parentObject="maneuver">
        <tooltipTargetDeltaRaan/>
      </exo-input-parametric>
      <exo-input-parametric class="mb-0 pb-0" :root="root" name="targetDeltaLtan" :parentObject="maneuver">
        <tooltipTargetDeltaLtan/>
      </exo-input-parametric>

      <exo-input-select alignWithParametricField :root="root" name="coastingDomain" :parentObject="maneuver">
        <tooltipCoastingDomain/>
      </exo-input-select>
      <exo-input-parametric :root="root" name="minCoastingAltitude" :parentObject="maneuver"/>
      <exo-input-parametric :root="root" name="maxCoastingAltitude" :parentObject="maneuver"/>
      <exo-input-parametric :root="root" name="minCoastingInclination" :parentObject="maneuver"/>
      <exo-input-parametric :root="root" name="maxCoastingInclination" :parentObject="maneuver"/>

      <exo-input-select alignWithParametricField :root="root" name="orbitPhasingOptimizationType" :parentObject="maneuver">
        <tooltipOrbitPhasingOptimizationType/>
      </exo-input-select>
      
      <exo-input-parametric :root="root" name="targetDeltaArgumentOfLatitude" :parentObject="maneuver"/>
      <exo-input-parametric class="mb-0 pb-0" :root="root" name="targetDeltaVmax" :parentObject="maneuver"/>
      <exo-input-parametric class="mb-0 pb-0" :root="root" name="targetMissionDurationForAol" :parentObject="maneuver"/>

      <exo-input-parametric :root="root"  :parentObject="maneuver" name="missionDuration" />
      <exo-input-parametric class="mb-0 pb-0" :root="root" :parentObject="maneuver" name="customSolarFlux">
      <tooltipCustomSolarFlux/>
      </exo-input-parametric>
      
      <exo-input-select alignWithParametricField :root="root" name="toleranceType" :parentObject="maneuver">  
      <tooltipSKToleranceType/>
      </exo-input-select>

      <exo-input-parametric class="mb-0 pb-0" :root="root" :parentObject="maneuver" name="alongTrackTolerance" />
      <exo-input-parametric class="mb-0 pb-0" :root="root" :parentObject="maneuver" name="smaTolerance" />

      <exo-input-double class="mb-0 pb-0" :root="root" :parentObject="maneuver" v-if="" name="negativeDeltaInclination"/>
      <v-row no-gutters v-if="root.inputs.enableMassLossAfterSubMissions === true && maneuver !== root.inputs.subMissions.slice(-1)[0]">
        <v-text-field horizontal
          :label="root.getFormLabel('massLossAfterSubMissions') + ' (kg)'"
          v-model="root.inputs.massLossAfterSubMissions[index]"
        >
        </v-text-field>
        <v-col cols="1">
        </v-col>
      </v-row>


    <div/>
    <v-btn v-on:click="root.removeSubMission(index)" icon class="mt-0 mb-4 pl-1 pb-1 pr-1 pt-0  align-middle">
        <icon scale="1.3" name="trash-alt"/>
     </v-btn>

  </div>
  `
  })
}
